.breadcrumbs {
  color: var(--tuna-content-secondary);
}

.typeLabel {
  display: inline;
}

.listItemText {
  overflow: hidden;
  padding-right: 32px;
}

.primaryText {
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
}
